










































import Vue from 'vue'
import { camelizeKeys } from '@/utils'

import ItemFactory from '../../elements/likert/ItemFactory'
import SurveyMixin from '../SurveyMixin'

const settings = camelizeKeys(require('./gad7.yml'))
const factory = new ItemFactory(settings)

export default Vue.extend({
  mixins: [SurveyMixin],
  data() {
    return {
      settings,
      items1Til7: factory.scanRange(1, 7),
      severityItem: factory.item('severityItem'),
    }
  },
})
